module.exports = __webpack_public_path__ + "static/media/sponsor186.c44bc51a.png";